<template>
  <div>
    <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' :color="color" :width="width"
      :height="height" />
    <div v-if="modalShow" class="modal fade" id="AddNewEpisodeModal" tabindex="-1"
      aria-labelledby="AddNewEpisodeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content AddNewChannelModal_content border-0">
          <div class="modal-header AddNewChannelModal_header">
            <h5 class="modal-title" id="UpdateChannelModalLabel">
              <img src="../../assets/images/left.svg" class="me-2" width="20" height="20" />
              Add New Episode
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent="postData" method="post">
            <!-- error messages for form validation -->
            <div v-if="errors.length">
              <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
            </div>

            <div class="modal-body">
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label">Episode Name</label>

                  </div>
                  <div class="col-12 col-md-8">
                    <input type="text" class="form-control bg-input border-0" name="e_name" v-model="name"
                      id="e_name" />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_image" class="form-label">Audio File</label>
                  </div>
                  <div class="col-12 col-md-8">
                    <input class="form-control bg-input border-0" type="file" name="e_audio" id="e_audio"
                      aria-describedby="audioHelp" accept="audio/*" @change="onFileChange" />
                    <div id="audioHelp" class="form-text">
                      * Preferred audio file *
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="reset" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">
                Close
              </button>
              <button type="submit" class="btn btn-primary btn-sm" :disabled="!audoFile">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import WaveformData from 'waveform-data';

export default {
  name: "AddEpisodeModal",
  components: { Loading },
  props: ["audioBook_id"],
  data() {
    return {
      errors: [],
      name: undefined,
      audoFile: undefined,
      audiobookTrackDuration: undefined,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "spinner",
      color: "rgb(218, 83, 46)",
      width:100,
      height:100,
      audioBookID: undefined,
      modalShow: true
    };
  },
  watch: {
    AudioBookName: function (newVal, oldVal) {
      this.audioBookID = this.audioBook_id;
      //this.audioFile = this.EpisodeFile;
    },
  },
  created() {
    console.log(this.audioBook_id)
  },
  methods: {
    processForm() {
      if (this.checkForm()) {
        this.postData();
      }
    },
    checkForm(e) {
      if (this.name && this.audoFile) {
        return true;
      }

      this.errors = [];

      if (!this.name) {
        this.errors.push("Name required.");
        return false;
      }
      if (!this.audoFile) {
        this.errors.push("Image required.");
        return false;
      }
      e.preventDefault();
      return false;
    },

    async onFileChange(event) {
      this.audoFile = event.target.files[0];
      await this.getAudiobookTrackDuration(this.audoFile);
    },
    async getAudiobookTrackDuration(file) {
      this.isLoading= true;
      const reader = new FileReader();
      let duration;
      reader.onload = async () => {
        const arrayBuffer = reader.result;
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        await audioContext.decodeAudioData(arrayBuffer, (audioBuffer) => {
          duration = audioBuffer.duration.toFixed(2);
        });
        this.audiobookTrackDuration = duration;
        console.log(this.audiobookTrackDuration)
        this.isLoading= false;
      };
      reader.readAsArrayBuffer(file);
    },
    async postData() {
      console.log(this.audioBook_id);
      this.isLoading = true;
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("audiobook_id", this.audioBook_id);
      formData.append("files", this.audoFile);
      formData.append("duration", this.audiobookTrackDuration);

      const token = localStorage.getItem(this.$tokenKey);
      try {
        // this.$baseUrl + this.$api + this.$version1 +
        const res = await axios.post(
            this.$baseUrl + this.$api + this.$version3 + "/audiobooks/addEpisode",
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        ).then((res) => {
          this.$swal.fire({
            icon: 'success',
            title: 'New added successfully',
            showConfirmButton: true,
          })
        })
        this.modalShow = false
        this.isLoading = false;
        if (res.status == 201 || res.status == 200) {
          // console.log("data", res.data);
          // this.$router.go();
          


        } else {
          this.$vToastify.info(
            "Something went wrong, please refresh and try again."
          ).then(() => {
            this.$swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Something went wrong!',
              footer: '<a href="">Why do I have this issue?</a>'
            })
          });
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
</style>
